import { Component } from '@angular/core';
import { Events } from 'ionic-angular';

import { IPTV }   from '../../providers/iptv/iptv';
import { Utils }  from '../../providers/utils/utils';
import { Fav }    from '../../providers/fav/fav';
import { FavApp } from '../../providers/favapp/favapp';
import { Api }    from '../../providers/api/api';
import { Deeplink } from '../../providers/deeplink/deeplink';

/*
*
*  Favorite Page
*
*/
@Component({
  selector: 'favorite',
  templateUrl: 'favorite.html'
})
export class Favorite {
    
    public favorites : any = [];
    public data: any = [];
    public empty : boolean;
    
    constructor(  
        public utils: Utils,
        public IPTV: IPTV,
        public api: Api,
        public events: Events,
        public fav: Fav,
        public favApp: FavApp,
        public deepLink: Deeplink
    ) {}

    doRefresh(refresher) {
        this.fetch().then(() => {
            refresher.complete();
        }, (err) => {
            refresher.complete();
            this.utils.error(err);
        });
    }

    ionViewDidLoad() {}

    fetch() {
        var i = 2;
        return new Promise((resolve, reject) => {

            this.fav.fetchPromise().then(() => {
                i--;
                if (!i) resolve();
            }, (err) => {
                reject(err);
            });

           this.favApp.fetchPromise().then(() => {
                i--;
                if (!i) resolve();
            }, (err) => {
                reject(err);
            });
        });
    }

    launchApplication(item) {

        if (this.IPTV.box.manufacturer == 'CHROMECAST') {
            this.utils.launchExternalApp(item);
        } else {
            let boxID = 0;

            for (let box of this.IPTV.boxs) {
                if (box.manufacturer == 'CHROMECAST') boxID = box.id;
            }

            this.utils.load();

            this.IPTV.setSource(boxID).then(() => {
                this.utils.unload();
                this.utils.launchExternalApp(item);
            }, (err) => {
                this.utils.unload();
                this.events.publish('live:error');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/favorite/favorite.ts